'use client'
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface DropdownContextType {
  activeDropdown: string | null;
  setActiveDropdown: (id: string | null) => void;
  isAnyDropdownOpen: boolean;
}

const DropdownContext = createContext<DropdownContextType>({
  activeDropdown: null,
  setActiveDropdown: () => {},
  isAnyDropdownOpen: false
});

interface DropdownProviderProps {
  children: ReactNode;
}

export const DropdownProvider: React.FC<DropdownProviderProps> = ({ children }) => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const handleSetActiveDropdown = (id: string | null) => {
    setActiveDropdown(id);
  };

  return (
    <DropdownContext.Provider 
      value={{
        activeDropdown,
        setActiveDropdown: handleSetActiveDropdown,
        isAnyDropdownOpen: activeDropdown !== null
      }}
    >
      {children}
    </DropdownContext.Provider>
  );
};

export const useDropdown = () => useContext(DropdownContext);